import {gsap} from "gsap";
import {
    SimplePresentation,
    SimplePresentationRunnerController
} from "../../../core/winpresentation/SimplePresentationRunner";
import {TheCrypt} from "../../TheCrypt";
import {APISetting} from "@nolimitcity/slot-launcher/bin/interfaces/APISettingsSystem";


export class DropInPresentation implements SimplePresentation {
    name:string = "DropInPresentation";
    shouldRun():boolean {
        return true;
    }

    start(controller:SimplePresentationRunnerController):void {
        const tl:gsap.core.Timeline = gsap.timeline();
        tl.add(() => controller.setSkipCallback(() =>{
            tl.timeScale(3);
        }));
        let padding:number = TheCrypt.gameFlowController.calculatePaddingDuration(TheCrypt.realArea.DROP_IN_REEL_DELAY*5)
        padding = (padding>0?padding:0);
        tl.add(TheCrypt.realArea.dropIn(padding));
        tl.add(()=>TheCrypt.reelAnticipation.fadeOutAnticipationSound());
        tl.addLabel("ending");
        tl.add(() => controller.finish());

        if (TheCrypt.apiPlugin.settings.get(APISetting.FAST_SPIN)){
            tl.timeScale(1.4);
        }

    }
}